import componentStyleOverrides from "./ComponentStyleOverrides";
import Palette from "./Palette";
import Typography from "./Typography";
import { createTheme } from "@mui/material";
import colors from '../../../assets/scss/_themes-vars.module.scss'

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

const themes = (customization) => {
    const color = colors;

    const themeOption = {
        colors: color,
        heading: color.successDark,
        textHeading: color.successDark,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.successLight,
        darkTextPrimary: color.successDark,
        darkTextSecondary: color.successDark,
        textDark: color.successDark,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
        customization
    }

    const themeOptions = {
        direction: 'ltr',
        palette: Palette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        typography: Typography(themeOption)
    };

    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOption);

    return {
        //...defaultTheme,
        ...themes
    }
};

const theme = themes();

export default theme;